const utils={
    // 对Date的扩展，将 Date 转化为指定格式的String   
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
    // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
    // 例子：   
    // (new Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423   
    // (new Date()).format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18   
    dateFormat:function (fmt) {
        var o = {
            "M+": this.getMonth() + 1,                 //月份   
            "d+": this.getDate(),                    //日   
            "h+": this.getHours(),                   //小时   
            "m+": this.getMinutes(),                 //分   
            "s+": this.getSeconds(),                 //秒   
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
            "S": this.getMilliseconds()             //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    /**
     * 秒数差转时分秒格式
     * @param second 秒数差
     * @return {string}
     */
    secondToDate: function (second) {
        var h = Math.floor(second / 3600) < 10 ? '0' + Math.floor(second / 3600) : Math.floor(second / 3600);
        var m = Math.floor((second / 60 % 60)) < 10 ? '0' + Math.floor((second / 60 % 60)) : Math.floor((second / 60 % 60));
        var s = Math.floor((second % 60)) < 10 ? '0' + Math.floor((second % 60)) : Math.floor((second % 60));
        return h + "时" + m + "分" + s+'秒';
    },
    /**
     *操作成功提示
     * @param that this指向
     * @param str 提示语
     */
    successTip(that,str) {
        that.$message({
            message: str,
            type: 'success',
            showClose: true,
            customClass: 'message-dim-success',
        });
    },
    /**
     *操作失败提示
     * @param that this指向
     * @param str 提示语
     */
    failTip(that,str) {
        that.$message({
            message: str,
            type: 'error',
            showClose: true,
            customClass: 'message-dim-fail',
        });
    },
    /**
     *操作失败提示
     * @param that this指向
     * @param str 提示语
     */
   warningTip(that,str) {
        that.$message({
            message: str,
            type: 'warning',
            showClose: true,
            customClass: 'message-dim-warning',
        });
    }

}

export default utils;


// WEBPACK FOOTER //
// ./assets/js/utils/utils.js